import DestinationByOriginPlacementI18nKeys from "./DestinationByOriginPlacement/DestinationByOriginPlacement.i18n";
import DestinationbyThemeCardI18nKeys from "./DestinationByThemePlacement/DestinationByThemeCard/DestinationByThemeCard.i18n";
import DestinationByThemePlacementI18nKeys from "./DestinationByThemePlacement/DestinationByThemePlacement.i18n";
import LuvStoriesCardI18nKeys from "./LuvStoriesPlacement/LuvStoryCard/LuvStoryCard.i18n";
import RotatingBannerPanelI18nKeys from "./RotatingBannerPlacement/RotatingBannerPanel/RotatingBannerPanel.i18n";
import RotatingBannerPlacementI18nKeys from "./RotatingBannerPlacement/RotatingBannerPlacement.i18n";
import SpecialOffersCardI18nKeys from "./SpecialOffersPlacement/SpecialOffersCard/SpecialOffersCard.i18n";

export default {
  ...DestinationByOriginPlacementI18nKeys,
  ...DestinationByThemePlacementI18nKeys,
  ...DestinationbyThemeCardI18nKeys,
  ...LuvStoriesCardI18nKeys,
  ...RotatingBannerPanelI18nKeys,
  ...RotatingBannerPlacementI18nKeys,
  ...SpecialOffersCardI18nKeys,
};
